import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2629ae5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label", "title"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-ellipsis-vertical",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-user-shield",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-language",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-chevron-right yt-guest-menu__chevron",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-globe",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-chevron-right yt-guest-menu__chevron",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yt-guest-menu__divider" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-gear",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yt-guest-menu__divider" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-regular fa-circle-question",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-regular fa-message",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-arrow-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yt-guest-menu__divider" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tiếng Việt", -1))
const _hoisted_17 = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "English", -1))
const _hoisted_19 = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-arrow-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yt-guest-menu__divider" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1))

import { computed, ref, watch } from 'vue'
import router from '@/router'
import { CONTACT, FAQ_PATH, RULES } from '@/const/path'


export default /*#__PURE__*/_defineComponent({
  __name: 'GuestMoreMenu',
  props: {
    langCode: { default: 'vn' },
    locationLabel: { default: 'Vietnam' }
  },
  emits: ["change-lang"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const open = ref(false)
const panel = ref<'main' | 'language' | 'location'>('main')

const langLabel = computed(() =>
  props.langCode === 'us' ? 'English' : 'Tiếng Việt'
)

watch(open, (val) => {
  if (!val) panel.value = 'main'
})

const close = () => {
  open.value = false
  panel.value = 'main'
}

const pickLang = (lang: 'vn' | 'us') => {
  emit('change-lang', lang)
  panel.value = 'main'
}

const goPrivacy = () => {
  close()
  router.push({ path: RULES }).catch(() => undefined)
}

const goSettings = () => {
  close()
  router.push({ path: CONTACT }).catch(() => undefined)
}

const goHelp = () => {
  close()
  router.push({ path: FAQ_PATH }).catch(() => undefined)
}

const goFeedback = () => {
  close()
  router.push({ path: CONTACT }).catch(() => undefined)
}

return (_ctx: any,_cache: any) => {
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createBlock(_component_a_dropdown, {
    open: open.value,
    "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((open).value = $event)),
    trigger: "click",
    placement: "bottomRight",
    "overlay-style": { zIndex: 1100 }
  }, {
    overlay: _withCtx(() => [
      _createElementVNode("div", {
        class: "yt-guest-menu",
        role: "menu",
        onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
      }, [
        (panel.value === 'main')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                type: "button",
                class: "yt-guest-menu__item",
                onClick: goPrivacy
              }, [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.yourData')), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "yt-guest-menu__item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (panel.value = 'language'))
              }, [
                _hoisted_5,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.displayLanguage', { lang: langLabel.value })), 1),
                _hoisted_6
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "yt-guest-menu__item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (panel.value = 'location'))
              }, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.locationLabel', { place: _ctx.locationLabel })), 1),
                _hoisted_8
              ]),
              _hoisted_9,
              _createElementVNode("button", {
                type: "button",
                class: "yt-guest-menu__item",
                onClick: goSettings
              }, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.settings')), 1)
              ]),
              _hoisted_11,
              _createElementVNode("button", {
                type: "button",
                class: "yt-guest-menu__item",
                onClick: goHelp
              }, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.help')), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "yt-guest-menu__item",
                onClick: goFeedback
              }, [
                _hoisted_13,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.sendFeedback')), 1)
              ])
            ], 64))
          : (panel.value === 'language')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "yt-guest-menu__back",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (panel.value = 'main'))
                }, [
                  _hoisted_14,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.language')), 1)
                ]),
                _hoisted_15,
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["yt-guest-menu__item", { 'is-active': _ctx.langCode === 'vn' }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (pickLang('vn')))
                }, [
                  _hoisted_16,
                  (_ctx.langCode === 'vn')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["yt-guest-menu__item", { 'is-active': _ctx.langCode === 'us' }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (pickLang('us')))
                }, [
                  _hoisted_18,
                  (_ctx.langCode === 'us')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                    : _createCommentVNode("", true)
                ], 2)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "yt-guest-menu__back",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (panel.value = 'main'))
                }, [
                  _hoisted_20,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.locationTitle')), 1)
                ]),
                _hoisted_21,
                _createElementVNode("button", {
                  type: "button",
                  class: "yt-guest-menu__item is-active",
                  onClick: close
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.locationLabel), 1),
                  _hoisted_22
                ])
              ], 64))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "yt-more-btn",
        "aria-label": _ctx.$t('header.more'),
        title: _ctx.$t('header.more'),
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, _hoisted_3, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})